import { handleWindowScrollDirection } from '../../scripts/utils/handleWindowScrollDirection';

export const initThemeHeaderNavigation = () => {
  const isExistProductBuyBanner = Boolean(
    document.querySelector('[data-product-buy-banner]')
  );
  const headerNavEl = document.querySelector('[data-theme-header-navigation]');

  if (isExistProductBuyBanner) {
    headerNavEl.classList.add(
      'theme-header-navigation--has-product-buy-banner'
    );
  }

  const headerSubNavEl = document.querySelector(
    '[data-theme-header-navigation-sub]'
  );
  const isExistHeaderSubNav = Boolean(
    headerSubNavEl ? headerSubNavEl.clientHeight : 0
  );

  if (!isExistHeaderSubNav || isExistProductBuyBanner) {
    return;
  }

  const detectableScrollOffset = 200; // NOTE: hardcoded
  const headerMainNav = document.querySelector(
    `[data-theme-header-navigation-main]`
  );
  let headerMainNavHeight = headerMainNav.clientHeight;

  if (headerMainNavHeight && headerNavEl) {
    const toggleVisibilityNav = (isVisible = true, isManualScroll) => {
      // NOTE: need to recalculate because el height changes on resize
      headerMainNavHeight = headerMainNav.clientHeight;

      let isDetectablePosition = true;

      if (isManualScroll) {
        isDetectablePosition = window.scrollY > detectableScrollOffset;
      }

      // NOTE: 1px for hide smartnav border
      const headerNavOffset =
        isVisible || !isDetectablePosition ? 0 : -(headerMainNavHeight + 1);
      const isDrawerOpened = document.body.hasAttribute('data-drawer-open');

      headerNavEl.style.transform = isDrawerOpened
        ? 0
        : `translateY(${headerNavOffset}px)`;

      const isScrollDown = Boolean(headerNavOffset);

      headerNavEl.setAttribute(
        'data-scroll-down',
        isScrollDown ? 'true' : 'false'
      );
    };

    handleWindowScrollDirection(
      (isManualScroll = true) => toggleVisibilityNav(true, isManualScroll),
      (isManualScroll = true) => toggleVisibilityNav(false, isManualScroll)
    );
  }
};

export const initThemeHeaderAddToCart = () => {
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  if (addToCartBtns) {
    addToCartBtns.forEach((addToCartBtn) => {
      addToCartBtn.addEventListener('click', () => {
        const addToCartBtnMultiplyProduct = document.querySelector(
          '.active [data-add-to-cart-submit]'
        );
        const addToCartBtnOneProduct = document.querySelector(
          '[data-add-to-cart-submit]'
        );

        const targetAddToCartBtn =
          addToCartBtnMultiplyProduct || addToCartBtnOneProduct || null;

        if (targetAddToCartBtn) {
          targetAddToCartBtn.click();
        }
      });
    });
  }
};
